module.exports = __webpack_public_path__ + "img/zgxq2.5c23000f.png";